const { isMobile, isIOS } = require("react-device-detect");

function josa(word, josaType) {
    const lastChar = word.charAt(word.length - 1);
    const lastCharCode = lastChar.charCodeAt(0);
    const jong = (lastCharCode - 0xAC00) % 28;
    
    // 한글의 유니코드 범위: 0xAC00 ~ 0xD7A3
    // 한글의 종성 여부는 (유니코드 - 0xAC00) % 28 값으로 판별 가능
    const hasFinalConsonant = jong !== 0;

    switch (josaType) {
        case '은는':
            return (hasFinalConsonant ? '은' : '는');
        case '이가':
            return (hasFinalConsonant ? '이' : '가');
        case '와과':
            return (hasFinalConsonant ? '과' : '와');
        case '을를':
            return (hasFinalConsonant ? '을' : '를');
        case '로으로':
            return (jong === 0 || jong === 8) ? '로' : '으로';
        default:
            return ''; // 입력한 조사 유형이 없을 경우, 그대로 반환
    }
}

const copyToClipboard = async (text) => {
    try {
      if(window.flutter_inappwebview)
        await window.flutter_inappwebview.callHandler('CustomChannel', 'COPY_TO_CLIPBOARD', text.toString());
      else
        await navigator.clipboard.writeText(text);
    } catch (err) {
      console.log(err);
    }
};
  
// 공유 기능을 호출하는 함수
const shareContent = async ( title, text ) => {
    if (navigator.share && isMobile) {
      try {
        await navigator.share({
          title: title,
          text: text
        });
      } catch (err) {
        console.error('공유 실패: ', err);
      }
    } else if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('CustomChannel', 'SHARE_REQUEST', text);
    } else {
      // 공유 기능을 사용할 수 없는 경우 클립보드에 복사
      await copyToClipboard(text);
      alert('핫플 URL 링크가 클립보드에 복사되었어요!\n함께 하고 싶은 친구에게 공유해볼까요?');
    }
};

const getImageFile = () => {
  return new Promise((resolve, reject) => {
      // 파일 선택을 위한 input element 생성
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = 'image/*'; // 이미지만 선택할 수 있도록 제한

      // 파일 선택이 완료되면 파일명과 파일 객체를 함께 반환
      inputElement.onchange = (event) => {
          const file = event.target.files[0];
          if (file) {
              const filePath = file.name; // 경로를 포함한 형식으로 반환
              resolve({ filePath, file });
          } else {
              reject(new Error('No file selected'));
          }
      };

      // 파일 선택 창을 강제로 띄움
      inputElement.click();
  });
};

const getFiles = () => {
  return new Promise((resolve, reject) => {
      // 파일 선택을 위한 input element 생성
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = 'image/*,video/*'; // 이미지와 영상 파일 모두 선택 가능
      inputElement.multiple = true; // 여러 개 파일 선택 가능

      inputElement.onchange = (event) => {
          const files = Array.from(event.target.files);
          if (files.length > 0) {
              resolve(files); // 선택한 파일들을 배열로 반환
          } else {
              reject(new Error('No files selected'));
          }
      };

      inputElement.click(); // 파일 선택 창을 띄움
  });
};

const normalizeBase64 = img => {
  if (img.startsWith('data:')) {
    return img;
  }
  else if (img.startsWith('R0lGOD')) {
    return `data:image/gif;base64,${img}`;
  }

  return `data:image/jpeg;base64,${img}`;
};

function formatNumber(num) {
  const abs = Math.abs(num);
  let formatted;
  let suffix = '';

  if (abs < 1000) {
    formatted = abs.toString();
  } else if (abs < 1_000_000) {
    // 천 단위: k
    const truncated = Math.floor((abs / 1000) * 10) / 10;
    formatted = truncated.toString();
    suffix = 'k';
  } else {
    // 백만 단위 이상: m
    const truncated = Math.floor((abs / 1_000_000) * 10) / 10;
    formatted = truncated.toString();
    suffix = 'm';
  }

  // 소수점 이하가 .0 이면 제거
  if (formatted.includes('.')) {
    formatted = formatted.replace(/\.0$/, '');
  }

  // 원본이 음수면 마이너스 붙이기
  return (num < 0 ? '-' : '') + formatted + suffix;
}

function formatKST(date) {
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
  const yyyy = tzDate.getFullYear();
  const mm = String(tzDate.getMonth() + 1).padStart(2, '0');
  const dd = String(tzDate.getDate()).padStart(2, '0');
  const hh = String(tzDate.getHours()).padStart(2, '0');
  const mi = String(tzDate.getMinutes()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
}

function haversineDistance(c1, c2) {
  const R = 6371; // km
  const [lat1, lon1] = [c1.lat, c1.long];
  const [lat2, lon2] = [c2.lat, c2.long];
  const dLat = (lat2 - lat1) * Math.PI/180;
  const dLon = (lon2 - lon1) * Math.PI/180;
  const a = Math.sin(dLat/2)**2
          + Math.cos(lat1 * Math.PI/180)
          * Math.cos(lat2 * Math.PI/180)
          * Math.sin(dLon/2)**2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function openInstagramMedia(instaUrl) {
  if(isIOS && instaUrl.includes('/p/') && isMobile){
    // 1) 숏코드 추출
    let path = '';
    try { path = new URL(instaUrl).pathname; } catch { path = String(instaUrl || ''); }
    const m = path.match(/\/(?:p|reel)\/([A-Za-z0-9\-_]+)\/?/);
    if (!m) throw new Error('Invalid Instagram URL: shortcode not found');
    const code = m[1];

    // 2) 파이썬 charmap 동일
    const CHAR_MAP = {
      A:'0',B:'1',C:'2',D:'3',E:'4',F:'5',G:'6',H:'7',I:'8',J:'9',
      K:'a',L:'b',M:'c',N:'d',O:'e',P:'f',Q:'g',R:'h',S:'i',T:'j',
      U:'k',V:'l',W:'m',X:'n',Y:'o',Z:'p',
      a:'q',b:'r',c:'s',d:'t',e:'u',f:'v',g:'w',h:'x',i:'y',j:'z',
      k:'A',l:'B',m:'C',n:'D',o:'E',p:'F',q:'G',r:'H',s:'I',t:'J',
      u:'K',v:'L',w:'M',x:'N',y:'O',z:'P',
      '0':'Q','1':'R','2':'S','3':'T','4':'U','5':'V','6':'W','7':'X','8':'Y','9':'Z',
      '-':'$','_':'_'
    };

    // ⚠️ JS의 Object.values 순서 왜곡 방지: 파이썬과 동일한 키 순서를 명시
    const ORDERED_KEYS = [
      ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      ...'abcdefghijklmnopqrstuvwxyz',
      ...'0123456789',
      '-', '_'
    ];
    const ALPHABET = ORDERED_KEYS.map(k => CHAR_MAP[k]); // 길이 64
    const VAL2IDX = Object.create(null);
    ALPHABET.forEach((ch, i) => { VAL2IDX[ch] = i; });

    // 3) 문자 치환
    let mapped = '';
    for (const ch of code) {
      const to = CHAR_MAP[ch];
      if (to === undefined) throw new Error(`Unsupported character in shortcode: "${ch}"`);
      mapped += to;
    }

    // ---- BigInt 없이 10진 문자열로 누적 계산 (result = result*64 + idx) ----
    function mulStrBySmallDecimal(numStr, mul) {
      if (numStr === '0') return '0';
      let carry = 0, out = '';
      for (let i = numStr.length - 1; i >= 0; i--) {
        const prod = (numStr.charCodeAt(i) - 48) * mul + carry;
        out = (prod % 10) + out;
        carry = Math.floor(prod / 10);
      }
      if (carry) out = carry + out;
      return out.replace(/^0+(?!$)/, '');
    }
    function addSmallToStr(numStr, add) {
      let carry = add, out = '';
      for (let i = numStr.length - 1; i >= 0; i--) {
        const sum = (numStr.charCodeAt(i) - 48) + carry;
        out = (sum % 10) + out;
        carry = Math.floor(sum / 10);
      }
      if (carry) out = carry + out;
      return out.replace(/^0+(?!$)/, '');
    }

    let dec = '0';
    for (const ch of mapped) {
      const idx = VAL2IDX[ch];
      if (idx === undefined) throw new Error(`Alphabet lookup failed for: "${ch}"`);
      dec = mulStrBySmallDecimal(dec, 64);
      dec = addSmallToStr(dec, idx);
    }

    window.open('instagram://media?id=' + dec);
  }
  else{
    window.open(instaUrl);
  }
}


module.exports = {
    josa,
    shareContent,
    copyToClipboard,
    getImageFile,
    getFiles,
    normalizeBase64,
    formatNumber,
    haversineDistance,
    openInstagramMedia,
    formatKST
};